<template>
  <div
    class="packed-circles__tooltip"
    :style="{
      top: `${top}px`,
      left: `${left}px`,
      visibility: value ? 'visible' : 'hidden',
    }"
  >
    <span class="packed-circles__tooltip-text" v-html="text" />
  </div>
</template>

<script>
export default {
  name: 'PackedCirclesTooltip',
  props: {
    value: Boolean, // show boolean
    text: String,
    top: Number,
    left: Number,
  },
};
</script>

<style lang="scss" scoped>
.packed-circles__tooltip {
  display: flex !important;
  font-family: 'Noto Sans Regular', sans-serif;
  position: absolute;
  pointer-events: none;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px;
  background: white;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.17);
  border-radius: 4px;
  max-width: 134px;
  z-index: 90;

  &-text {
    width: fit-content;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18.9px;
    color: black;
    flex: none;
    order: 0;
    align-self: center;
    flex-grow: 0;
  }
}
</style>
